import { render, staticRenderFns } from "./SkeletonTableList.vue?vue&type=template&id=e108e1fe&scoped=true&"
import script from "./SkeletonTableList.vue?vue&type=script&lang=js&"
export * from "./SkeletonTableList.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonTableList.vue?vue&type=style&index=0&id=e108e1fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e108e1fe",
  null
  
)

export default component.exports